/* eslint-disable */
import { Field, Formik } from 'formik';
import _ from 'lodash';
import moment from 'moment';
import { Fragment, useRef, useState } from 'react';
import { BsFillBriefcaseFill, BsPersonCircle } from 'react-icons/bs';
import RegistrationService from 'scripts/services/RegistrationService';
import { IconCheckbox } from 'src/bxDesign/form/IconCheckbox';
import AddressInput from 'src/design/components/addressInput/AddressInputV2';
import PrimaryButton from 'src/design/components/button/PrimaryButton';
import DateOfBirth from 'src/design/components/dateOfBirth/DateOfBirth';
import FileUpload from 'src/design/components/fileUpload/FileUpload';
import FormCheckbox from 'src/design/components/formCheckbox/FormCheckbox';
import FormSelect from 'src/design/components/formSelect/FormSelect';
import InfoBox from 'src/design/components/infoBox/InfoBox';
import Spacing from 'src/design/styleguide/spacing/Spacing';
import Colors from 'src/themes/brickx/colors';
import Styledlink from 'src/design/components/hyperlink/Styledlink';
import { themeForAdvisorAccount } from 'src/themes/landingPageThemes';
import { cleanString } from 'src/utils/textutils';
import styled from 'styled-components';

const Layout = styled.div`
  .formItemGroup {
    padding: 15px 0;
  }
  .formItemGroup {
    label {
      display: block;
      font-size: 22px;
      margin-bottom: 10px;
    }
    ul {
      li {
        font-size: 20px;
      }
    }
  }

  .formItemGroupInsideRow {
    margin: 15px 0;
    input[type='checkbox'] {
      margin-right: 10px;
    }
  }

  .noteSection {
  }

  .checkbox-group {
    display: flex;
    align-items: center;
    padding: 20px 0;
    & > div {
      margin-right: 10px;
    }
  }

  h3,
  h4 {
    border-left: solid 4px var(--bx-color---purple-600);
    color: var(--bx-color---purple-600);
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .error {
    text-transform: i;
  }

  p.question {
    margin-bottom: 20px;
    font-size: 22px;
  }

  table {
    width: 100%;
    tr {
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
      td {
        padding: 5px;
        min-width: 150px;
        font-size: 18px;
      }
    }
  }

  .note {
    color: #888;
  }
`;

const TwoButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
`;

// Utils
const addressFormatter = (addressReport) => {
  return `${addressReport.companyAddressStreetNumber} ${addressReport.companyAddressStreetName} ${addressReport.companyAddressStreetType}, ${addressReport.companyAddressSuburb} ${addressReport.companyAddressState} ${addressReport.companyAddressPostcode}`;
};

const HelpLink = () => (
  <Spacing top="normal">
    <div>
      <a
        href="mailto:info@brickx.com?subject=Contact Us: Adviser Onboarding Questions"
        target="_blank"
      >
        Need Help?
      </a>
    </div>
  </Spacing>
);

const ASICExtractUpload = ({
  values,
  setFieldValue,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className="formItemGroup">
      <h3>Upload your ASIC Professional Register Extract</h3>
      <label>
        Find your Document(s) at{' '}
        <Styledlink
          href="https://service.asic.gov.au/search/"
          forceExternal
          target="_blank"
        >
          ASIC Search Service
        </Styledlink>
        <br />
        <small>(PDF format only - upload in one file less than 10MB)</small>
      </label>
      <FileUpload
        ctaText="Select File"
        onChange={(file) => {
          if (file) {
            const r = new FileReader();
            r.readAsDataURL(file);
            r.onloadend = (e) => {
              const base64Str = e.target.result.split(',')[1];
              setFieldValue('asicExtractDocumentTitle', file.name);
              setFieldValue('asicExtractDocumentAsString', base64Str);
            };
          }
        }}
        accept=".pdf"
      />
    </div>
  );
};

/**
 *
 * Advisor Onboarding Form
 *
 * @param {*} param0
 * @returns
 */

const AdvisorOnboarding = ({
  userData,
  setAdvisorDetails,
  onSubmit,
  identityVerificationFormErrors,
}) => {
  const [isLoading, setLoading] = useState(false);
  const [errMsg, setErrorMsg] = useState(null);
  const [formData, setFormData] = useState({});
  const [abnLookupResult, setAbnLookupResult] = useState({});
  const [acnLookupResult, setAcnLookupResult] = useState({});
  const [step, setStep] = useState(0);
  const [formValues, setFormValues] = useState(null);
  const verificationInFlight = useRef(false);

  const validateAflsNumberFormat = (afslNumber) => `${afslNumber}`.length === 6;
  const validateAbnFormat = (abn) => `${abn}`.length === 11;
  const validateAcnFormat = (acn) => `${acn}`.length === 9;

  const onConfirm = async (formData) => {
    if (verificationInFlight.current) return;
    let abnResult = {};
    let acnResult = {};
    if (!validateAflsNumberFormat(formData.afslNumber)) {
      setErrorMsg('Please provide a valid AFSL Number');
      return;
    }
    if (!validateAbnFormat(formData.abn)) {
      setErrorMsg('Please provide a valid ABN');
      return;
    }
    if (!validateAcnFormat(formData.acn)) {
      setErrorMsg('Please provide a valid ACN');
      return;
    }
    if (errMsg) {
      setErrorMsg(null);
    }
    verificationInFlight.current = true;
    setLoading(true);

    const enteredAcn = formData.acn;
    acnResult = await RegistrationService.verifyAcn(enteredAcn).catch(
      (e) => console.log(e), // eslint-disable-line no-console
    );
    if (!acnResult) {
      setErrorMsg('ACN provided cannot be found, please check again.');
      verificationInFlight.current = false;
      setLoading(false);
      return;
    }
    setAcnLookupResult(acnResult);

    const enteredAbn = formData.abn;
    abnResult = await RegistrationService.verifyAbn(enteredAbn).catch(
      (e) => console.log(e), // eslint-disable-line no-console
    );
    if (!abnResult) {
      setErrorMsg('ABN provided cannot be found, please check again.');
      verificationInFlight.current = false;
      setLoading(false);
      return;
    }
    setAbnLookupResult(abnResult);

    setFormData(formData);
    const companyName = acnResult.companyName;
    const formatDob = (day, month, year) => {
      return moment(`${year}-${month}-${day}`).format('DD-MM-YYYY');
    };
    const advisorDetails = {
      tfn: '123456782',
      companyName: companyName,
      afslNumber: formData.afslNumber,
      street: cleanString(
        `${acnResult.companyAddressStreetNumber} ${acnResult.companyAddressStreetName} ${acnResult.companyAddressStreetType}`,
      ),
      suburb: acnResult.companyAddressSuburb,
      state: acnResult.companyAddressState,
      postcode: acnResult.companyAddressPostcode,
      abn: formData.abn,
      acn: formData.acn,
      corpAuthorisedRepNumber: formData.corpAuthorisedRepNumber,
      asicExtractDocumentTitle: formData.asicExtractDocumentTitle,
      asicExtractDocumentAsString: formData.asicExtractDocumentAsString,
    };
    if (setAdvisorDetails) setAdvisorDetails(advisorDetails);
    setFormValues(formData);
    setStep(1);
    verificationInFlight.current = false;
    setLoading(false);
    window.scrollTo(0, 0);
  };

  if (step === 0) {
    return (
      <Layout>
        <Formik
          initialValues={
            formValues || {
              tfn: '',
              companyName: '',
              afslNumber: '',
              abn: '',
              acn: '',
              corpAuthorisedRepNumber: '',
              asicExtractDocumentTitle: '',
              asicExtractDocumentAsString: '',
            }
          }
          onSubmit={onConfirm}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              dirty,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              handleReset,
              setFieldValue,
            } = props;
            const isFormValid =
              values.abn !== '' &&
              values.acn !== '' &&
              values.afslNumber !== '' &&
              values.corpAuthorisedRepNumber !== '' &&
              values.asicExtractDocumentTitle !== '' &&
              values.asicExtractDocumentAsString !== '';
            return (
              <form onSubmit={handleSubmit}>
                <div className="formItemGroup">
                  <label htmlFor="afslNumber">AFSL Number:</label>
                  <input
                    className="large"
                    id="afslNumber"
                    placeholder="Enter a valid Australian Financial Services License Number (AFSL)"
                    type="number"
                    value={values.afslNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="formItemGroup">
                  <label htmlFor="abn">ABN of your Company:</label>
                  <input
                    className="large"
                    id="abn"
                    placeholder="Enter a valid Australian Business Number (ABN)"
                    type="number"
                    value={values.abn}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="formItemGroup">
                  <label htmlFor="acn">ACN of your Company:</label>
                  <input
                    className="large"
                    id="acn"
                    placeholder="Enter a valid Australian Company Number (ACN)"
                    type="number"
                    value={values.acn}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="formItemGroup">
                  <label htmlFor="corpAuthorisedRepNumber">
                    Corporate Authorised Representative Number:
                  </label>
                  <input
                    className="large"
                    id="corpAuthorisedRepNumber"
                    placeholder="Enter a valid Corporate Authorised Representative Number"
                    type="number"
                    value={values.corpAuthorisedRepNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>

                <ASICExtractUpload
                  values={values}
                  setFieldValue={setFieldValue}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                />

                <div className="formItemGroup">
                  Note: Pressing NEXT means that you agree that BrickX may
                  perform the relevant regulatory searches supporting your
                  application.
                </div>

                <div className="formItemGroup">
                  {errMsg && (
                    <Spacing bottom="normal">
                      <InfoBox critical>{errMsg}</InfoBox>
                    </Spacing>
                  )}
                  {isLoading && (
                    <Spacing bottom="normal">
                      <InfoBox>We're verifying your details...</InfoBox>
                    </Spacing>
                  )}
                  <PrimaryButton
                    disabled={!isFormValid || isLoading || isSubmitting}
                    color={PrimaryButton.colors.PURPLE}
                    fullWidth
                    arrow
                  >
                    NEXT
                  </PrimaryButton>
                </div>
              </form>
            );
          }}
        </Formik>
      </Layout>
    );
  } else if (step === 1) {
    return (
      <Layout>
        <p>
          <strong>Please Confirm your Details:</strong>
        </p>
        <br />
        <table>
          <tbody>
            <tr>
              <td>Company Name</td>
              <td>
                <strong>{acnLookupResult.companyName}</strong>
              </td>
            </tr>
            <tr>
              <td>AFSL Number</td>
              <td>
                <strong>{formData.afslNumber}</strong>
              </td>
            </tr>
            <tr>
              <td>ABN</td>
              <td>
                <strong>{formData.abn}</strong>
              </td>
            </tr>
            <tr>
              <td>ABN Entity Name</td>
              <td>
                <strong>{abnLookupResult.trustName}</strong>
              </td>
            </tr>
            <tr>
              <td>ACN</td>
              <td>
                <strong>{formData.acn}</strong>
              </td>
            </tr>
            <tr>
              <td>ACN Entity Name</td>
              <td>
                <strong>{acnLookupResult.companyName}</strong>
              </td>
            </tr>
            <tr>
              <td>Company Registered Address</td>
              <td>
                <strong>{addressFormatter(acnLookupResult)}</strong>
              </td>
            </tr>
            <tr>
              <td>Corporate Authorised Representative Number</td>
              <td>
                <strong>{formData.corpAuthorisedRepNumber}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <TwoButtonGroup>
          <PrimaryButton onClick={() => setStep(0)}>Not correct?</PrimaryButton>
          <PrimaryButton
            onClick={() => {
              onSubmit();
            }}
            color={PrimaryButton.colors.PURPLE}
            arrow
          >
            CONFIRM
          </PrimaryButton>
        </TwoButtonGroup>
        <HelpLink />
      </Layout>
    );
  }
};

export default AdvisorOnboarding;
